import React, { useCallback, useEffect, useState } from 'react';
import { Button, Grid, Header, Icon, Loader, Segment } from 'semantic-ui-react';
import { useParams, Link } from 'react-router-dom';
import NavBarGuest from '../components/NavBar/NavBarGuest';
import BackgroundRandomizer from '../components/Tools/BackgroundRandomizer';
import { confirmEmailChange } from '../services/Settings';
import { getLocalServerConfig } from '../services/Server';

function EmailChangePage() {
  const { token } = useParams();
  const [state, setState] = useState({ sending: true, done: false, error: '' });
  const timerRef = React.useRef(null);

  const handleConfirm = useCallback(() => {
    confirmEmailChange(token)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setState({ sending: false, done: true, error: '' });
          timerRef.current = setTimeout(() => {
            localStorage.clear();
            window.location.href = '/';
          }, 8000);
        } else {
          setState({ sending: false, done: false, error: response.data.message });
        }
      })
      .catch((e) => {
        setState({ sending: false, done: false, error: e.message });
      });
  }, [token]);

  useEffect(() => {
    document.title = `${getLocalServerConfig().siteName || 'Ergo'} | Confirmation de changement d'email`;
    handleConfirm();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [handleConfirm]);

  return (
    <BackgroundRandomizer>
      <NavBarGuest />
      <Grid
        textAlign="center"
        style={{ overflowY: 'scroll', height: '100vh' }}
        verticalAlign="middle"
      >
        <Grid.Column style={{ maxWidth: 900 }}>
          <Segment className="transparent-table">
            <br />
            <Header as="h2" color="teal">
              <Icon name={state.done ? 'check' : 'mail'} />
              Confirmation du changement d&apos;email
            </Header>
            <br />
            {state.sending && (
              <>
                <Loader active content="Confirmation en cours..." />
                <br />
                <br />
                <br />
              </>
            )}
            {state.done && (
              <>
                <Header as="h4">Votre adresse email a été modifiée avec succès.</Header>
                <Header.Subheader>
                  Toutes vos sessions ont été révoquées. Vous allez être redirigé vers la connexion
                  dans 8 secondes...
                </Header.Subheader>
                <br />
                <br />
              </>
            )}
            {state.error && (
              <>
                <div>
                  <span className="text-danger">{state.error}</span>
                </div>
                <br />
                <Button
                  icon="user"
                  label="Mon Compte"
                  labelPosition="right"
                  color="teal"
                  size="large"
                  as={Link}
                  to="/account"
                />
                <br />
                <br />
              </>
            )}
          </Segment>
        </Grid.Column>
      </Grid>
    </BackgroundRandomizer>
  );
}

export default EmailChangePage;
